import React, { useEffect, useState } from 'react';
import { ResponsiveBar } from '@nivo/bar';

function BarChart(props) {
	React.useEffect(() => {}, [props]);
	const [constant, setConstant] = useState(1);
	useEffect(() => {
		let value = [];
		if (props.data) {
			props.data.map((data) => {
				if (data.value > 0) {
					value.push(data.value);
				}
				return null;
			});
			let minVAl = Math.min(...value);
			setConstant(minVAl);
		}
	}, [props]);
	//eslint-disable-next-line
	const BarComponent = (barProps) => {
		return (
			<g transform={`translate(${barProps.bar.x}, ${barProps.bar.y})`}>
				<rect
					width={16}
					height={barProps.bar.height}
					fill={barProps.bar.color}
					strokeWidth="0"
					stroke="white"
					rx={barProps.borderRadius}
					onClick={() => {
						if (props.onClick) props.onClick(barProps);
					}}
					onMouseOver={(event) => {
						if (!props.cursor) return;
						event.target.style.cursor = 'pointer';
					}}
				></rect>
				<text
					y={-10} // the important bit!!
					x={8}
					textAnchor="middle"
					dominantBaseline="central"
					style={{
						fontSize: 10,
						pointerEvents: 'none',
						fill: 'black',
					}}
				>
					{barProps.bar.data.value}
				</text>
			</g>
		);
	};

	const getAxis = () => {
		let obj = {
			axisBottom: {
				tickSize: 5,
				tickPadding: 5,
				tickRotation: 0,
				legendPosition: 'middle',
				legendOffset: 32,
			},
			axisLeft: null,
		};
		if (props.axisLegends) {
			if (props.axisLegends.bottom) {
				obj.axisBottom.legend = props.axisLegends.bottom;
				obj.axisBottom.legendOffset = 42;
			}
			if (props.axisLegends.left) {
				obj.axisLeft = {
					tickSize: 0,
					tickPadding: 0,
					tickRotation: 0,
					legendPosition: 'middle',
					legendOffset: 32,
					legend: props.axisLegends.left,
					format: function (value) {
						return '';
					},
				};
			}
		}
		return obj;
	};
	return (
		<ResponsiveBar
			data={props.data}
			indexBy="range"
			margin={{ top: 30, right: 30, bottom: 50, left: 20 }}
			padding={0.75}
			innerPadding={4}
			// barComponent={BarComponent}
			valueScale={{ type: 'symlog', constant: constant }}
			// valueScale={{ type: 'linear' }}
			indexScale={{ type: 'band', round: true }}
			colors={props.color}
			borderRadius={5}
			borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
			axisTop={null}
			axisRight={null}
			{...getAxis()}
			labelSkipWidth={12}
			labelSkipHeight={0}
			enableGridX={false}
			enableGridY={false}
			labelTextColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
			legends={[]}
			// labelFormat={(d) => (
			// 	<tspan style={{ fontSize: 10, fontWeight: 500, fill: 'black' }} y={-10}>
			// 		{d}
			// 	</tspan>
			// )}
			label={(d) => (
				<tspan style={{ fontSize: 10, fontWeight: 500, fill: 'black' }} y={-8}>
					{d.value}
				</tspan>
			)}
			motionConfig={{
				mass: 1,
				tension: 170,
				friction: 26,
				clamp: false,
				precision: 0.01,
				velocity: 0,
			}}
			tooltip={() => {
				return null;
			}}
			theme={{
				tooltip: {
					container: {
						backgroundColor: 'none',
						boxShadow: 'none',
					},
				},
				grid: {
					line: {
						strokeWidth: 1,
						strokeDasharray: '14 14',
					},
				},
				fontSize: 9,
				axis: {
					legend: {
						text: {
							fontSize: 13,
						},
					},
				},
			}}
			onClick={(e) => {
				if (props.onClick) props.onClick(e);
			}}
			onMouseEnter={(_data, event) => {
				if (props.cursor) event.target.style.cursor = 'pointer';
			}}
		/>
	);
}

export default BarChart;
